export class PaymentSettings {
    constructor(
        public paypalPaymentSettings?: PaypalPaymentSettings,
        public kassa24PaymentSettings?: Kassa24PaymentSettings,
        public stripePaymentSettings?: StripePaymentSettings,
        public cloudpaymentsPaymentSettings?: CloudpaymentsPaymentSettings
    ) {
        this.paypalPaymentSettings = paypalPaymentSettings ? paypalPaymentSettings : null;
        this.kassa24PaymentSettings = kassa24PaymentSettings ? kassa24PaymentSettings : null;
        this.stripePaymentSettings = stripePaymentSettings ? stripePaymentSettings : null;
        this.cloudpaymentsPaymentSettings = cloudpaymentsPaymentSettings ? cloudpaymentsPaymentSettings : null;
    }
}

export class PaypalPaymentSettings {
    constructor(
        public enabled?: boolean,
        public providerType?: PaymentProvider,
        public transactionFeeMinimum?: number,
        public transactionFeePercentage?: number,
        public clientId?: string,
        public clientSecret?: string,
        public intent?: string,
        public transactionEndpoint?: string
    ) {
        this.enabled = enabled ? enabled : false;
        this.providerType = providerType ? providerType : null;
        this.transactionFeeMinimum = transactionFeeMinimum ? transactionFeeMinimum : null;
        this.transactionFeePercentage = transactionFeePercentage ? transactionFeePercentage : null;

        this.clientId = clientId ? clientId : '';
        this.clientSecret = clientSecret ? clientSecret : '';
        this.intent = intent ? intent : 'CAPTURE';
        this.transactionEndpoint = transactionEndpoint ? transactionEndpoint : '';
    }
}

export class Kassa24PaymentSettings {
    constructor(
        public enabled?: boolean,
        public providerType?: PaymentProvider,
        public transactionFeeMinimum?: number,
        public transactionFeePercentage?: number,
        public clientId?: string,
        public clientSecret?: string,
        public intent?: string,
        public callbackEndpoint?: string
    ) {
        this.enabled = enabled ? enabled : false;
        this.providerType = providerType ? providerType : null;
        this.transactionFeeMinimum = transactionFeeMinimum ? transactionFeeMinimum : null;
        this.transactionFeePercentage = transactionFeePercentage ? transactionFeePercentage : null;
        this.clientId = clientId ? clientId : '';
        this.clientSecret = clientSecret ? clientSecret : '';
        this.intent = intent ? intent : 'CAPTURE';
        this.callbackEndpoint = callbackEndpoint ? callbackEndpoint : '';
    }
}

export class StripePaymentSettings {
    constructor(
        public enabled?: boolean,
        public providerType?: PaymentProvider,
        public transactionFeeMinimum?: number,
        public transactionFeePercentage?: number,
        public publishableKey?: string,
        public secretKey?: string,
        public displayCardHolderName?: boolean,
        public webHookEndPointSecret?: string
    ) {
        this.enabled = enabled ? enabled : false;
        this.providerType = providerType ? providerType : null;
        this.transactionFeeMinimum = transactionFeeMinimum ? transactionFeeMinimum : null;
        this.transactionFeePercentage = transactionFeePercentage ? transactionFeePercentage : null;
        this.publishableKey = publishableKey ? publishableKey : '';
        this.secretKey = secretKey ? secretKey : '';
        this.displayCardHolderName = displayCardHolderName ? displayCardHolderName : false;
        this.webHookEndPointSecret = webHookEndPointSecret ? webHookEndPointSecret : null;
    }
}
export class CloudpaymentsPaymentSettings {
    constructor(
        public enabled?: boolean,
        public providerType?: PaymentProvider,
        public transactionFeeMinimum?: number,
        public transactionFeePercentage?: number,
        public publicId?: string,
        public apiPassword?: string
    ) {
        this.enabled = enabled ? enabled : false;
        this.providerType = providerType ? providerType : PaymentProvider.CLOUDPAYMENTS;
        this.transactionFeeMinimum = transactionFeeMinimum ? transactionFeeMinimum : null;
        this.transactionFeePercentage = transactionFeePercentage ? transactionFeePercentage : null;
        this.publicId = publicId ? publicId : '';
        this.apiPassword = apiPassword ? apiPassword : '';
    }
}

export const PaymentProvider = {
    PAYPAL: 'PAYPAL',
    KASSA24: 'KASSA24',
    STRIPE: 'STRIPE',
    CLOUDPAYMENTS: 'CLOUDPAYMENTS',
} as const;
export type PaymentProvider = (typeof PaymentProvider)[keyof typeof PaymentProvider];
